import apiAction from 'common/redux/actions/apiAction';
import {GET_UPG_MY_TEAMS_PROFILE_DEPARTMENT_FILTER_URL} from  '../apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const getMyTeamsProfileDepartmentFilter = (data) => {
    return {
      type: 'GET_UPG_MY_TEAM_PROFILE_DEPARTMENT_FILTER',
      payload: data,
    };
  };
export const MyTeamsProfileDepartmentFilterAction= configParams => {
    return apiAction.postAPI({
        url: GET_UPG_MY_TEAMS_PROFILE_DEPARTMENT_FILTER_URL(),
        data: configParams,
        onSuccess: getMyTeamsProfileDepartmentFilter,
        onFailure: (err) => logError('Error fetching department filter values...:', err),
        label: 'FETCH_UPG_MY_TEAM_PROFILE_DEPARTMENT_FILTER',
      }); 
}